import React from "react";
import './Class.css';

const HORARIOS = [
    {
        local: 'Marinha Grande',
        turmas: [
            { dias: 'Segunda, quarta e sexta', hora: '19:00' },
            { nome: 'Treino Kids', dias: 'Terça e sexta', hora: '18:00' },
        ],
    },
    { local: 'Fátima', turmas: [{ dias: 'Terça e quinta', hora: '19:00' }] },
    { local: 'Caxarias', turmas: [{ dias: 'Segunda e quarta', hora: '19:00' }] },
    { local: 'São Martinho do Porto', turmas: [{ dias: 'Terça e quinta', hora: '19:00' }] },
];

const Class = () => {
    return (
        <section id="class" className="s_class">
            <h2 className="section-title">Dias e horários</h2>
            <ul className="card-grid">
                {HORARIOS.map(({ local, turmas }) => (
                    <li key={local} className="info-card class-card">
                        <h3>{local}</h3>
                        <div className="turmas">
                            {turmas.map((t, i) => (
                                <div key={i} className="turma">
                                    {t.nome && <span className="class-tag">{t.nome}</span>}
                                    <p className="turma-dias">{t.dias}</p>
                                    <p className="turma-hora">{t.hora}</p>
                                </div>
                            ))}
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Class;
